import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useMaintenanceMode() {
  const queryClient = useQueryClient();

  const { data: isMaintenanceMode = false, isLoading } = useQuery({
    queryKey: ["site-settings", "maintenance_mode"],
    queryFn: async () => {
      const { data, error } = await (supabase as any)
        .from("site_settings")
        .select("value")
        .eq("key", "maintenance_mode")
        .maybeSingle();
      if (error || !data) return false;
      // value is jsonb – could be raw boolean or wrapped
      const val = data.value;
      return val === true || val === "true";
    },
    staleTime: 5_000,
    refetchOnWindowFocus: true,
  });

  const toggleMutation = useMutation({
    mutationFn: async (enabled: boolean) => {
      console.log("[maintenance] Toggling to:", enabled);
      const { error, data: updateData } = await (supabase as any)
        .from("site_settings")
        .update({ value: enabled })
        .eq("key", "maintenance_mode")
        .select();
      console.log("[maintenance] Update result:", { error, updateData });
      if (error) throw error;
      if (!updateData || updateData.length === 0) {
        console.error("[maintenance] No rows updated! Check RLS policies.");
        throw new Error("Nie udało się zaktualizować ustawienia. Sprawdź uprawnienia.");
      }
      return enabled;
    },
    onMutate: async (enabled: boolean) => {
      await queryClient.cancelQueries({ queryKey: ["site-settings", "maintenance_mode"] });
      const previous = queryClient.getQueryData<boolean>(["site-settings", "maintenance_mode"]);
      queryClient.setQueryData(["site-settings", "maintenance_mode"], enabled);
      return { previous };
    },
    onError: (_err: any, _enabled: boolean, context: any) => {
      if (context?.previous !== undefined) {
        queryClient.setQueryData(["site-settings", "maintenance_mode"], context.previous);
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["site-settings", "maintenance_mode"] });
    },
  });

  return {
    isMaintenanceMode,
    isLoading,
    toggleMaintenance: (enabled: boolean) => toggleMutation.mutate(enabled),
    isToggling: toggleMutation.isPending,
  };
}
